export default {
    setTitle: 'setTitle',
    setShowNavbar: 'setShowNavbar',
    setNavbarColor: 'setNavbarColor',
    setShowTabbar: 'setShowTabbar',
    activeTabbar: 'activeTabbar',
    loadMemberAsync: 'loadMemberAsync',
    setMember: 'setMember',
    refreshMemberAsync: "refreshMemberAsync",
    loadOrderNoticeAsync: 'loadOrderNoticeAsync',
    loadOrderOptionsAsync: 'loadOrderOptionsAsync'
}